const cacheKeys = {
  qrCode: "qrCode",
};

export default cacheKeys;
